module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-10.dd1f8c47.mp3";